export default "__VITE_ASSET__p2$mX8NN__"